<template>
  <div class="section center" id="n3Section">
    <div class="l-700 text-blue mb-4" data-aos="fade-down">
      A política do negacionismo
    </div>
    <video
      autoplay
      loop
      class="img-moro"
      src="@/assets/images/negacionismo.mp4"
    ></video>
    <p class="mt-5 text text-justify" data-aos="fade-down">
      / / /
      <br />
      <br />

      Em 2021 o Observatório Direitos Humanos Crise e Covid-19 produziu um
      estudo sobre o Plano de Vacinação nos estados e capitais do Brasil.
      <br />
      <br />
      O levantamento reuniu os dados disponíveis nos sites das secretarias
      estaduais e municipais de saúde, nos sites que veiculam informações
      oficiais sobre o coronavírus vinculados a essas secretarias, nos sites das
      prefeituras ou governos estaduais. O trabalho do Observatório comprovou
      que, em março de 2021, mesmo estando entre o público prioritário em 14
      unidades da federação, a população privada de liberdade estava incluída
      apenas nas últimas fases da estratégia vacinal.
      <br />
      <br />
      O objetivo é evidenciar o grau de transparência das informações sobre a
      gestão em saúde durante a pandemia e analisar, a partir das informações
      públicas dos governos, as decisões quanto à priorização dos grupos a serem
      vacinados contra Covid-19.
      <br />
      <br />
      As buscas foram realizadas entre os dias 01 e 14 de março de 2021 e
      coletaram informações sobre:
      <br />
      <br />
      • Disponibilidade do Plano (estadual ou municipal) de Vacinação na
      internet conforme diretrizes da Lei de Acesso à Informação <br />
      • Data de lançamento dos Planos de Vacinação <br />
      • Número de fases de cada Plano<br />
      • Grupos prioritários e fase prevista para vacinação de cada grupo
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}
.text-blue {
  margin-top: 60px;
  background-color: #427ea7;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}
</style>